import React from 'react';
import classes from './AutoSuggestListItem.scss';

const autoSuggestListItem = (props) => {
    let listItemClass = [classes.ListItem];
    if (props.active) {
        listItemClass.push(classes.ListItemActive);
    }

    let list = null;

    if (props.listType === 'flight') {
        list = <li 
            className={listItemClass.join(' ')}
            onMouseEnter={() => props.hoverInHandler(props.itemIndex)}
            onMouseLeave={() => props.hoverOutHandler(props.itemIndex)} 
            onClick={(event) => props.cityClicked(event, 
            props.flights[0].ac, 
            props.flights[0].cc, 
            props.flights[0].ct, 
            props.flights[0].cn,
            props.type)
            }>
            <div className={`u-flex align-items-start justify-content-between`}>
                <div>
                    <h4 className={`u-textColorDark u-fontWeightRegular u-fontSize16 u-lineHeight1 mb-1`}>{props.city}, {props.country}</h4>
                    <span className={`u-textColorLight u-fontWeightRegular u-fontSize11 u-lineHeight1 u-block`}>{props.flights[0].an}</span>
                </div>
                <div className={classes.Box}>
                    {props.flights[0].ac}
                </div>
            </div>
        </li>;
    } else if (props.listType === 'hotel') {
        list = <li 
            className={listItemClass.join(' ')}
            onMouseEnter={() => props.hoverInHandler(props.itemIndex)}
            onMouseLeave={() => props.hoverOutHandler(props.itemIndex)} 
            onClick={(event) => props.cityClicked(event)
            }>
            <div className={`u-flex align-items-start justify-content-between`}>
                <div>
                    <h4 className={`u-textColorDark u-fontWeightRegular u-fontSize16 u-lineHeight1 mb-1`}>{props.cities.displayName}</h4>
                    <span className={`u-textColorLight u-fontWeightRegular u-fontSize11 u-lineHeight1 u-block`}>{props.cities.countryName}</span>
                </div>
                <div className={classes.Box}>
                    {props.cities.countryCode}
                </div>
            </div>
        </li>;
    }

    return list;
}

export default autoSuggestListItem;


// WEBPACK FOOTER //
// ./src/components/UI/AutoSuggestBox/AutoSuggestList/AutoSuggestListItem/AutoSuggestListItem.js